"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var core_1 = require("@unform/core");
var styles_1 = require("./styles");
var SwitchButton = function (_a) {
    var name = _a.name, rest = __rest(_a, ["name"]);
    var inputRef = react_1.useRef(null);
    var _b = core_1.useField(name), fieldName = _b.fieldName, defaultValue = _b.defaultValue, registerField = _b.registerField;
    var _c = __read(react_1.useState(false), 2), checked = _c[0], setChecked = _c[1];
    react_1.useEffect(function () {
        registerField({
            name: fieldName,
            ref: inputRef.current,
            path: 'checked',
            setValue: function (ref, value) {
                if (value) {
                    setChecked(!!value);
                }
            },
        });
    }, [fieldName, registerField]);
    return (jsx_runtime_1.jsx(styles_1.Container, __assign({ onClick: function () { return setChecked(!checked); }, checked: checked }, { children: jsx_runtime_1.jsx("div", __assign({ className: "switch-content" }, { children: jsx_runtime_1.jsx("input", __assign({ type: "checkbox", checked: checked, name: name, ref: inputRef, defaultValue: defaultValue, readOnly: true }, rest), void 0) }), void 0) }), void 0));
};
exports.default = SwitchButton;
//# sourceMappingURL=index.js.map